var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Container, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useWebgate } from "@xvia/webgate-connect";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { InformacaoVeiculo } from "../../components/InformacaoVeiculos";
import Loader from "../../components/Loading";
import styles from "./index.module.css";
import { ChevronLeft } from "@mui/icons-material";
var VEICULOS = [
    {
        placa: "LVI4I81",
        renavam: 1315067266,
        chassi: "WV1NHX1SNKP770046",
        marca: "VW",
        modelo: "I AMAROK CD 4X4 S",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2019,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: true,
    },
    {
        placa: "LVI5A98",
        renavam: 1315066782,
        chassi: "WV1NHX1SNKP770041",
        marca: "VW",
        modelo: "I AMAROK CD 4X4 S",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2019,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "LVI1B89",
        renavam: 1315066820,
        chassi: "WV1NHX1SNKP770045",
        marca: "VW",
        modelo: "I AMAROK CD 4X4 S",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2019,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "LVJ9361",
        renavam: 594594790,
        chassi: "936ZAA1SNJP770088",
        marca: "PEUGEOT",
        modelo: "208 GRIFFE A",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2018,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "LVK0477",
        renavam: 585724482,
        chassi: "936ZAA1SNJP770089",
        marca: "PEUGEOT",
        modelo: "208 GRIFFE A",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2018,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "LVI1B74",
        renavam: 1315066413,
        chassi: "936ZAA1SNJP770077",
        marca: "PEUGEOT",
        modelo: "208 GRIFFE A",
        anoLicenciamento: 2023,
        anoFabricacao: 2018,
        anoModelo: 2018,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: false,
        quantMultas: 17,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "LVI6A40",
        renavam: 1315051114,
        chassi: "936ZAA1SNJP770022",
        marca: "PEUGEOT",
        modelo: "208 GRIFFE A",
        anoLicenciamento: 2021,
        anoFabricacao: 2018,
        anoModelo: 2018,
        restricaoJudicial: false,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
    {
        placa: "ABC0101",
        renavam: 1067197424,
        chassi: "9BFZH54J3J8254947",
        marca: "VW",
        modelo: "I FUSCA SEDAN",
        anoLicenciamento: 2018,
        anoFabricacao: 2018,
        anoModelo: 2018,
        restricaoJudicial: true,
        restricaoAdministrativa: false,
        restricaoTributaria: false,
        licenciamentoAtrasado: true,
        quantMultas: 0,
        quantLicenciamentos: 0,
        totalLicenciamentos: 0,
        indicadorIntencaoVenda: false,
    },
];
var VeiculosPorProprietario = function () {
    var _a = useWebgate(), userInfo = _a.userInfo, portalConnect = _a.portalConnect;
    var history = useHistory();
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), dadosVeiculoSimples = _c[0], setDadosVeiculoSimples = _c[1];
    useEffect(function () {
        if (userInfo && Array.isArray(userInfo === null || userInfo === void 0 ? void 0 : userInfo.veiculos)) {
            setDadosVeiculoSimples(userInfo.veiculos);
        }
        else {
            setDadosVeiculoSimples(VEICULOS);
        }
        setLoading(false);
    }, [userInfo]);
    var handleBotaoVoltar = function () {
        history.goBack();
    };
    return (_jsxs(Container, __assign({ id: "container-index" }, { children: [_jsxs(Box, __assign({ justifyContent: "center", alignItems: "end", marginBottom: 3, marginTop: 3 }, { children: [_jsxs("div", __assign({ className: "button-with-title" }, { children: [_jsx(Button, __assign({ color: "primary", sx: { color: "#717171" }, variant: "text", onClick: handleBotaoVoltar, startIcon: _jsx(ChevronLeft, { color: "secondary", sx: { color: "#717171" } }) }, { children: "Voltar" })), _jsx(Typography, __assign({ fontWeight: "bold", variant: "h4", marginBottom: 5, sx: { color: "#034ea2" } }, { children: "IPVA" }))] })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(Grid, __assign({ flexDirection: "row", className: styles.containerTopo, display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }, { children: _jsx(Typography, __assign({ fontWeight: "bold", variant: "h5", gutterBottom: true, marginBottom: 0, lineHeight: 0 }, { children: "Seus Veiculos" })) })), _jsx("hr", {})] }))] })), _jsx(ToastContainer, {}), _jsx(Box, { className: styles.header }), _jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), _jsx(Box, { children: dadosVeiculoSimples && !loading && (_jsx(InformacaoVeiculo, { veiculos: dadosVeiculoSimples })) })] })));
};
export default VeiculosPorProprietario;
